module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"blob-util","commonjs":"blob-util","commonjs2":"blob-util","root":"blobUtil"}
 ** module id = 2
 ** module chunks = 0 1
 **/